import React, { useContext, useEffect, useRef, useState } from 'react';
import '../classes/styles/style.css';
import * as WS from '../webServices/cyMyManager'
import Screen from '../components/screen';
import Spinner from '../components/spinner';
import { Editor as EditorRef } from "tinymce/tinymce";
import { GetGlobalContext, GlobalContextData } from '../classes/context';
import ActionBtn from '../components/actionBtn';
import Modal from '../components/modal';
import { Editor } from '@tinymce/tinymce-react';
import { formatTime, parseTime } from '../classes/utility';
import { Alignment, Bold, ClassicEditor, Essentials, FontColor, Heading, Italic, List, Mention, Paragraph, Table, Undo } from 'ckeditor5';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import TableSedi from '../mobile-components/tableSedi';

export default function Sedi() {
    const globalContext = useContext<GlobalContextData>(GetGlobalContext);

    const [sedi, setSedi] = useState<WS.Plus.IF.SedeEsercente[] | undefined>(undefined);

    const [sedeSel, setSedeSel] = useState<WS.Plus.IF.SedeEsercente | undefined>(undefined);

    const [modalShow, setModalShow] = useState(false)

    // const editorRef = useRef<EditorRef | undefined>(undefined);
    const [editorText, setEditorText] = useState("")
    const [hideEdit, setHideEdit] = useState<boolean>(true);

    const [denominazione, setDenominazione] = useState<string>('');
    const [sostInfoSede, setSostInfoSede] = useState<boolean>(false);
    const [durataPre, setDurataPre] = useState<number>(0);
    const [imageBase64, setImageBase64] = useState<string>('');
    const [orari, setOrari] = useState<WS.Plus.IF.OrarioSedeEserc[]>([]);
    const [chiusure, setChiusure] = useState<WS.Plus.IF.GiornoChiuSediEserc[]>([]);
    const [orariErr, setOrariErr] = useState<{ NumProg: number; error: string; }[]>([]);
    const [chiusureErr, setChiusureErr] = useState<{ NumProg: number; error: string; }[]>([]);
    const [eleSegmenti, setEleSegmenti] = useState<WS.Plus.IF.VeiSegmento[]>([]);
    const [eleSegmentiSedi, setEleSegmentiSedi] = useState<WS.Plus.IF.VeiSegmentiRicarSediEserc[]>([]);
    const [segmRicarSel, setSegmRicarSel] = useState<WS.Plus.IF.VeiSegmentiRicarSediEserc>(WS.Plus.IF.VeiSegmentiRicarSediEsercInit());

    const [alertWrap, setAlertWrap] = useState<string>('alert-wrap');

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const updateListaSedi = async () => {
        const data = await WS.Plus.getListaSediEsercenti(WS.UT.TOKEN, "", globalContext.vars.esercente?.Id ?? 0, 0, 0, 1, 0);
        setSedi(data.list);
    };

    useEffect(() => {
        updateListaSedi()
    }, []);

    const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            const reader = new FileReader();
            reader.onload = (loadEvent: any) => {
                if (loadEvent.target.result.length > 1398101) // 1Mb * 4 / 3
                    alert('Il file indicato è troppo grande, selezionare un file di massimo 1Mb.')
                else
                    setImageBase64(loadEvent.target.result.split(',')[1] ?? '');
            };
            reader.readAsDataURL(file);
        }
    };

    const fileInputRef = useRef<HTMLInputElement>(null);

    const triggerFileSelect = () => fileInputRef.current?.click();

    const viewOperOK = () => {
        setModalShow(false)
        setAlertWrap('alert-wrap alert-show');

        setTimeout(() => {
            setAlertWrap('alert-wrap');
        }, 3000)
    }

    const updateSedi = async (body: WS.Plus.IF.SedeEsercente): Promise<WS.Plus.IF.GenericResponse> => {
        if (orariErr.some(x => x.error !== '') || chiusureErr.some(x => x.error !== '')) {
            alert('Correggere gli errori prima di salvare!');
            return WS.Plus.IF.GenericErrorResponse('Correggere gli errori prima di salvare!');
        }

        body.Denominazione = denominazione;
        body.Info = editorText;
        body.SostInfoEse = sostInfoSede ? 1 : 0;
        body.imgFile = imageBase64;
        body.orari = orari;
        body.chiusure = chiusure;
        body.DurataPreno = durataPre;

        let res = await WS.Plus.updateSedeEsercente(WS.UT.TOKEN, body)

        if (sedeSel && (sedeSel.Id ?? 0) > 0)
            for (let i = 0; i < eleSegmentiSedi.length; i++) {
                if (eleSegmentiSedi[i].Ricarico === 0 || isNaN(eleSegmentiSedi[i].Ricarico) || eleSegmentiSedi[i].Ricarico === null || eleSegmentiSedi[i].Ricarico === undefined) {
                    await WS.Plus.deleteVeiSegmentoSede(WS.UT.TOKEN, eleSegmentiSedi[i].IdVeiSegmento, sedeSel.Id);
                }
                else {
                    await WS.Plus.updateVeiSegmentoSede(WS.UT.TOKEN, eleSegmentiSedi[i]);
                }
            }

        await updateListaSedi()

        if (res.isOk)
            viewOperOK()

        return res;
    }


    const clearForm = () => {
        setDenominazione('');
        setSostInfoSede(false);
        setImageBase64('');
        setOrari([]);
        setChiusure([]);
        setDurataPre(0);
    }

    const passToModal = async (sede: WS.Plus.IF.SedeEsercente) => {
        let eseSeg = await WS.Plus.getListaVeiSegmenti(WS.UT.TOKEN, '', 0, 0, 0);
        let eseSegSedi = await WS.Plus.getListaVeiSegmentiSedi(WS.UT.TOKEN, '', 0, 0, 0, sede.Id);

        setDenominazione(sede.Denominazione)
        setSostInfoSede(sede.SostInfoEse === 1)
        setImageBase64(sede.imgFile)
        setOrari(sede.orari)
        setChiusure(sede.chiusure)
        setDurataPre(sede.DurataPreno)


        // editorRef.current?.setContent(sede.Info)
        setEditorText(sede.Info)

        setSedeSel(sede)
        setModalShow(true);
        setEleSegmenti(eseSeg.list);
        setEleSegmentiSedi(eseSegSedi.list);
    }

    const triggerOrariDelete = (idRiga: number) => {
        setOrari(orari.filter(x => x.NumProg !== idRiga))
    }

    const triggerOrariAdd = () => setOrari(orari.concat({
        ...WS.Plus.IF.OrarioSedeEsercInit(),
        IdSedeEserc: sedeSel!.Id,
        NumProg: orari.length === 0 ?
            1 :
            Math.max(...orari.map(x => x.NumProg)) + 1
    }))

    useEffect(() => {
        let newErr: { NumProg: number; error: string; }[] = [];

        orari.forEach(orario => {
            newErr.push({
                NumProg: orario.NumProg,
                error: (orario.OraDalle >= orario.OraAlle) ? "Ora dalle deve essere minore di ore alle" : ""
            })
        });

        setOrariErr(newErr);
    }, [orari]);


    const triggerChiusureDelete = (idRiga: number) => {
        setChiusure(chiusure.filter(x => x.NumProg !== idRiga))
    }

    const triggerChiusureAdd = () => setChiusure(chiusure.concat({
        ...WS.Plus.IF.GiornoChiuSediEsercInit(),
        IdSedeEserc: sedeSel!.Id,
        NumProg: chiusure.length === 0 ?
            1 :
            Math.max(...chiusure.map(x => x.NumProg)) + 1
    }))

    useEffect(() => {
        let newErr: { NumProg: number; error: string; }[] = [];

        chiusure.forEach(chiusura => {
            newErr.push({
                NumProg: chiusura.NumProg,
                error: (chiusura.Mese === 2 && chiusura.Giorno > 29) ? "'Febbraio ha massimo 29 giorni'" :
                    ((chiusura.Mese == 11 || chiusura.Mese == 4 || chiusura.Mese == 6 || chiusura.Mese == 9) && chiusura.Giorno > 30) ? "Il mese indicato ha massimo 30 giorni" : ""
            })
        });

        setChiusureErr(newErr);
    }, [chiusure]);

    const modalBody = (): JSX.Element =>
        <div>
            <div className='row'>
                <div className='col-12 col-md-6 mb-3'>
                    <label htmlFor="nomeAbb">Denominazione </label>
                    <input className="form-control " type="text" placeholder="Inserisci denominazione se diversa da default..." value={denominazione} onChange={(n) => setDenominazione(n.target.value)} />
                </div>
                <div className='row mt-3'>
                    <div className={'col-12'}>
                        <CKEditor
                            editor={ClassicEditor}
                            data={sedeSel?.Info ?? ''}

                            onChange={(evt, editor) => {
                                setEditorText(editor.getData())
                            }}
                            config={{
                                toolbar: {
                                    items: ['undo', 'redo', '|', 'heading', 'bold', 'italic', '|', 'fontColor', 'alignment', 'bulletedList', 'numberedList'],
                                },
                                plugins: [
                                    Bold, Essentials, Italic, Mention, Paragraph, Undo, Heading, FontColor, Alignment, List
                                ],
                                // mention: {
                                //     // Mention configuration
                                // },
                                initialData: sedeSel?.Info ?? '',
                            }}
                        />
                        {/* <Editor
                            apiKey='5lw8qa6a4fg7sdr0a35o79qbjzlkx6f12hi9j8ul39wfieeg'
                            onInit={(evt, editor) => {
                                editorRef.current = editor;
                                setHideEdit(false);
                            }}
                            initialValue={sedeSel?.Info ?? ''}
                            init={{
                                height: 300,
                                width: '100%',
                                menubar: false,
                                plugins: [
                                    // Elenco dei plugin
                                ],
                                toolbar: 'undo redo | blocks | ' +
                                    'bold italic forecolor | alignleft aligncenter ' +
                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                    'removeformat | help | myCustomButton',
                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                            }}
                        /> */}
                    </div>
                </div>
                <div className='col-12 col-md-6 mb-3'>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" checked={sostInfoSede} onChange={rico => setSostInfoSede(rico.target.checked)} />
                        <label className="form-check-label" htmlFor="flexCheckDefault">
                            Sostituisci informazioni sede
                        </label>
                    </div>
                </div>
                <div className='col-12'>
                    <div className="form-check" style={{ padding: '0px' }}>
                        <div className='d-flex justify-content-center w-100'>
                            <div className="image-container w-100 d-flex justify-content-center align-items-center form-control" style={{ minHeight: '200px', maxHeight: '400px', position: 'relative', }}>
                                {imageBase64 ? (
                                    <img src={'data:image/png;base64,' + imageBase64} alt="Logo Sede" style={{ width: '100%', height: '100%', maxHeight: '350px', objectFit: 'contain' }} />
                                ) : (
                                    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <span>Nessuna immagine</span>
                                    </div>
                                )}
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    onChange={handleImageChange}
                                    style={{ display: 'none' }}
                                    accept="image/*"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-12 my-2' >
                    <div className='wrapper-action-btn'>
                        <button className='btn btn-success' onClick={triggerFileSelect}>
                            <i className="bi bi-pencil"></i>
                            <span> Seleziona</span>
                        </button>
                    </div>
                </div>
                <div className='col-12 col-md-6 mb-3'>
                    <label>Durata prenotazione (in minuti)</label>
                    <input className="form-control " type="number" placeholder="Inserisci la durata di una prenotazione da App..." value={durataPre} onChange={(n) => setDurataPre(isNaN(parseInt(n.target.value)) ? 0 : parseInt(n.target.value))} />
                </div>
                <div className='col-12 card'>
                    <label>Fasce orarie</label>
                    <table className="table">
                        <thead>
                            <th scope='col'>Giorno</th>
                            <th scope='col'>Ora dalle</th>
                            <th scope='col'>Ora alle</th>
                            <th scope='col'>Slot Prenotazioni</th>
                            <th scope='col'> </th>
                        </thead>
                        <tbody>
                            {orari.map(orario =>
                                <React.Fragment key={orario.NumProg}>
                                    <tr>
                                        <td style={{ alignContent: 'center' }}>
                                            <select className='form-select' style={{ border: 0 }} value={orario.Giorno} onChange={giorno => {
                                                let newOrari = [...orari];
                                                let prog = newOrari.findIndex(x => x.NumProg === orario.NumProg);
                                                newOrari[prog].Giorno = parseInt(giorno.target.value);
                                                setOrari(newOrari)
                                            }}>
                                                <option value={1}>Lunedì</option>
                                                <option value={2}>Martedì</option>
                                                <option value={3}>Mercoledì</option>
                                                <option value={4}>Giovedì</option>
                                                <option value={5}>Venerdì</option>
                                                <option value={6}>Sabato</option>
                                                <option value={7}>Domenica</option>
                                            </select>
                                        </td>
                                        <td style={{ alignContent: 'center' }}>
                                            <input className='form-control' style={{ border: 0, flex: 1 }} type='time' value={formatTime(orario.OraDalle)} onChange={oraDalle => {
                                                let newOrari = [...orari];
                                                let prog = newOrari.findIndex(x => x.NumProg === orario.NumProg);
                                                newOrari[prog].OraDalle = parseTime(oraDalle.target.value);
                                                setOrari(newOrari)
                                            }} />
                                        </td>
                                        <td style={{ alignContent: 'center' }}>
                                            <input className='form-control' style={{ border: 0, flex: 1 }} type='time' value={formatTime(orario.OraAlle)} onChange={oraAlle => {
                                                let newOrari = [...orari];
                                                let prog = newOrari.findIndex(x => x.NumProg === orario.NumProg);
                                                newOrari[prog].OraAlle = parseTime(oraAlle.target.value);
                                                setOrari(newOrari)
                                            }} />
                                        </td>
                                        <td style={{ alignContent: 'center' }}>
                                            <input className='form-control' style={{ border: 0, flex: 1 }} type='number' value={orario.QtaGestibile} onChange={qta => {
                                                let newOrari = [...orari];
                                                let prog = newOrari.findIndex(x => x.NumProg === orario.NumProg);
                                                newOrari[prog].QtaGestibile = parseInt(qta.target.value);
                                                setOrari(newOrari)
                                            }} />
                                        </td>
                                        <td style={{ alignContent: 'center' }}>
                                            <td>
                                                <div className='wrapper-action-btn'>
                                                    <button className='btn btn-danger' onClick={() => triggerOrariDelete(orario.NumProg)}>
                                                        <i className="bi bi-trash"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </td>
                                    </tr>
                                    <>
                                        {orariErr.find(x => x.NumProg === orario.NumProg)?.error !== "" && (
                                            <tr>
                                                <td colSpan={5} style={{ color: 'red', fontSize: '12px', paddingLeft: 10, paddingTop: 0, paddingBottom: 0 }}>
                                                    {orariErr.find(x => x.NumProg === orario.NumProg)?.error}
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                </React.Fragment>
                            )}
                            <tr className='tr-no-hover' style={{ border: 'none' }}>
                                <td style={{ border: 'none' }}>
                                    <div className='wrapper-action-btn'>
                                        <button className='btn btn-success' onClick={triggerOrariAdd}>
                                            <i className="bi bi-plus"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='col-12 card'>
                    <label>Giorni chiusure</label>
                    <table className="table">
                        <thead>
                            <th scope='col'>Giorno</th>
                            <th scope='col'>Mese</th>
                            <th scope='col'> </th>
                        </thead>
                        <tbody>
                            {chiusure.map(chiusura =>
                                <React.Fragment key={chiusura.NumProg}>
                                    <tr>
                                        <td style={{ alignContent: 'center' }}>
                                            <select className='form-select' style={{ border: 0 }} value={chiusura.Giorno} onChange={giorno => {
                                                let newChiusure = [...chiusure];
                                                let prog = newChiusure.findIndex(x => x.NumProg === chiusura.NumProg);
                                                newChiusure[prog].Giorno = parseInt(giorno.target.value);
                                                setChiusure(newChiusure)
                                            }}>
                                                {Array.from({ length: 31 }).map((_, i) =>
                                                    <option value={i + 1}>{i + 1}</option>
                                                )}
                                            </select>
                                        </td>
                                        <td style={{ alignContent: 'center' }}>
                                            <select className='form-select' style={{ border: 0 }} value={chiusura.Mese} onChange={mese => {
                                                let newChiusure = [...chiusure];
                                                let prog = newChiusure.findIndex(x => x.NumProg === chiusura.NumProg);
                                                newChiusure[prog].Mese = parseInt(mese.target.value);
                                                setChiusure(newChiusure)
                                            }}>
                                                <option value={1}>Gennaio</option>
                                                <option value={2}>Febbraio</option>
                                                <option value={3}>Marzo</option>
                                                <option value={4}>Aprile</option>
                                                <option value={5}>Maggio</option>
                                                <option value={6}>Giugno</option>
                                                <option value={7}>Luglio</option>
                                                <option value={8}>Agosto</option>
                                                <option value={9}>Settembre</option>
                                                <option value={10}>Ottobre</option>
                                                <option value={11}>Novembre</option>
                                                <option value={12}>Dicembre</option>
                                            </select>
                                        </td>
                                        <td style={{ alignContent: 'center' }}>
                                            <td>
                                                <div className='wrapper-action-btn'>
                                                    <button className='btn btn-danger' onClick={() => triggerChiusureDelete(chiusura.NumProg)}>
                                                        <i className="bi bi-trash"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </td>
                                    </tr>
                                    <>
                                        {orariErr.find(x => x.NumProg === chiusura.NumProg)?.error !== "" && (
                                            <tr>
                                                <td colSpan={5} style={{ color: 'red', fontSize: '12px', paddingLeft: 10, paddingTop: 0, paddingBottom: 0 }}>
                                                    {orariErr.find(x => x.NumProg === chiusura.NumProg)?.error}
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                </React.Fragment>
                            )}
                            <tr className='tr-no-hover' style={{ border: 'none' }}>
                                <td style={{ border: 'none' }}>
                                    <div className='wrapper-action-btn'>
                                        <button className='btn btn-success' onClick={triggerChiusureAdd}>
                                            <i className="bi bi-plus"></i>
                                            {/* <span> Aggiungi</span> */}
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='col-12 card mt-3'>
                    <label>Ricarichi Segmenti</label>
                    <table className="table">
                        <thead style={{ borderBottomWidth: 1 }}>
                            <th scope='col'>Segmento</th>
                            <th scope='col'>Ricarico €</th>
                            <th scope='col'> </th>
                        </thead>
                        <tbody>
                            {eleSegmenti.map(segmento =>
                                <React.Fragment key={segmento.Id}>
                                    <tr>
                                        <td style={{ alignContent: 'center' }}>
                                            <span>{segmento.Descrizione}</span>
                                        </td>
                                        <td>
                                            <div className='col-12 col-md-6'>
                                                {/* <label htmlFor="prezzoAbb">Ricarico €</label> */}
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    placeholder=""
                                                    value={eleSegmentiSedi.find(x => x.IdVeiSegmento === segmento.Id)?.Ricarico ?? 0}
                                                    onChange={(num) => {
                                                        let posSegSed = eleSegmentiSedi.findIndex(x => x.IdVeiSegmento === segmento.Id);

                                                        let newSegSedi = [...eleSegmentiSedi];

                                                        if (posSegSed == -1)
                                                            newSegSedi.push({ IdVeiSegmento: segmento.Id, desSegmento: segmento.Descrizione, IdSedeEserc: sedeSel?.Id ?? 0, Ricarico: parseFloat(num.target.value), sedeEserc: WS.Plus.IF.SedeEsercenteInit() });
                                                        else
                                                            newSegSedi[posSegSed].Ricarico = parseFloat(num.target.value)

                                                        setEleSegmentiSedi(newSegSedi);
                                                    }}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                </React.Fragment>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    // return (
    //     <Screen>
    //         <div className='container'>
    //             <div className='row card mb-3'>
    //                 <h2>Sedi</h2>
    //             </div>
    // <div className='row'>
    //     <div className='col-12 card'>
    //         <table className="table">
    //             <thead>
    //                 <tr>
    //                     <th scope="col">#</th>
    //                     <th scope="col">Indirizzo</th>
    //                 </tr>
    //             </thead>
    //             <tbody>
    //                 {sedi ?
    //                     sedi.map((sede, s) =>
    //                         <tr key={s}>
    //                             <th scope="row">{sede.Id}</th>
    //                             <td>{sede.Indirizzo}</td>
    //                         </tr>
    //                     )
    //                     :
    //                     <Spinner />
    //                 }
    //             </tbody>
    //         </table>
    //     </div>
    // </div>
    //         </div>
    //     </Screen>
    // );

    return (
        <Screen>
            <div className='container'>
                <div className={alertWrap}>
                    <div className="alert alert-primary" role="alert">Operazione Effettuata!</div>
                </div>
                <div className='row'>
                    <div className='d-flex card flex-row mb-3' >
                        <h2>Sedi</h2>
                        <div className='ms-auto'>
                            <ActionBtn
                                modello='Abbonamenti'
                                add={false}
                                del={false}
                                // onDel={onMultipleDelete}
                                modalOnSave={() => updateSedi(sedeSel ?? WS.Plus.IF.SedeEsercenteInit())}
                                modalOnClose={() => clearForm()}
                                modalBody={modalBody()}
                                // onNew={clearForm}
                                sedi={sedi}
                            // sedeSel={filSedeSel}
                            // setSedeSel={setFilSedeSel}
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 card'>
                        <table className="table">

                            <thead>
                                <tr>{!isMobile ?
                                    <>
                                        <th scope="col">#</th>
                                        <th scope="col">Denominazione</th>
                                        <th scope="col">Indirizzo</th>
                                    </>
                                    :
                                    <></>
                                }
                                </tr>
                            </thead>
                            <tbody>
                                {sedi ?
                                    sedi.map((sede, index) =>
                                        isMobile ?
                                            <TableSedi sede={sede} passToModal={() => passToModal(sede)} />
                                            :
                                            <tr className='pointer' key={index} >
                                                <td onClick={() => passToModal(sede)}>{sede.Id}</td>
                                                <td onClick={() => passToModal(sede)}>{sede.Denominazione}</td>
                                                <td onClick={() => passToModal(sede)}>{sede.Indirizzo}</td>
                                            </tr>
                                    )
                                    :
                                    undefined
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <Modal
                isShow={modalShow}
                onClose={() => setModalShow(false)}
                // onDel={async () => {
                //     if (sedeSel?.Id)
                //         await deleteAbb(sedeSel?.Id);
                // }}
                title="Modifica sede"
                body={
                    modalBody()
                }
                onSave={() => updateSedi(sedeSel ?? WS.Plus.IF.SedeEsercenteInit())}
            />
        </Screen>
    );

}

